var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bordered d-flex align-items-center",class:_vm.callInfo.iconColorClass},[_c('div',{staticClass:"circle-icon centralize"},[_c('feather-icon',{attrs:{"icon":_vm.callInfo.icon,"size":"18"}})],1),_vm._v(" "+_vm._s(_vm.callInfo.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }